export default __webpack_public_path__ + "static/media/card4.9a84eba8.png";